export default "__VITE_ASSET__BVzT5MwC__"